/* global BigInt, globalThis */

const KEY_PACKAGE_REF_LABEL = 'MLS 1.0 KeyPackage Reference';
const KEY_PACKAGE_REF_LABEL_BYTES = Uint8Array.from(
  Array.from(KEY_PACKAGE_REF_LABEL, (character) => character.charCodeAt(0)),
);

const encodeTlsVectorLength = (value) => {
  const length = Number(value);
  if (!Number.isSafeInteger(length) || length < 0 || length > 0x3fffffffffffffff) {
    return null;
  }

  const byteLength =
    length <= 0x3f ? 1 : length <= 0x3fff ? 2 : length <= 0x3fffffff ? 4 : 8;
  const output = new Uint8Array(byteLength);
  let remaining = BigInt(length);
  for (let index = byteLength - 1; index >= 0; index -= 1) {
    output[index] = Number(remaining & 0xffn);
    remaining >>= 8n;
  }
  output[0] |= byteLength === 1 ? 0x00 : byteLength === 2 ? 0x40 : byteLength === 4 ? 0x80 : 0xc0;
  return output;
};

const concatBytes = (...chunks) => {
  const parts = chunks.filter((chunk) => chunk instanceof Uint8Array && chunk.length > 0);
  const output = new Uint8Array(parts.reduce((sum, chunk) => sum + chunk.length, 0));
  let offset = 0;
  parts.forEach((chunk) => {
    output.set(chunk, offset);
    offset += chunk.length;
  });
  return output;
};

const digestNameForCiphersuite = (ciphersuite) => {
  const suite = Number(ciphersuite);
  if (!Number.isFinite(suite)) return 'SHA-256';
  switch (suite & 0xffff) {
    case 0x0004:
    case 0x0005:
    case 0x0006:
      return 'SHA-512';
    case 0x0007:
      return 'SHA-384';
    default:
      return 'SHA-256';
  }
};

const bytesToHex = (bytes) => {
  if (!(bytes instanceof Uint8Array) || bytes.length === 0) return null;
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
};

export const buildMlsKeyPackageRefInput = (keyPackageBytes) => {
  if (!(keyPackageBytes instanceof Uint8Array) || keyPackageBytes.length === 0) {
    return null;
  }
  const labelLength = encodeTlsVectorLength(KEY_PACKAGE_REF_LABEL_BYTES.length);
  const valueLength = encodeTlsVectorLength(keyPackageBytes.length);
  if (!labelLength || !valueLength) return null;
  return concatBytes(labelLength, KEY_PACKAGE_REF_LABEL_BYTES, valueLength, keyPackageBytes);
};

export const computeMlsKeyPackageRefHex = async ({
  keyPackageBytes,
  ciphersuite,
  cryptoRef = globalThis?.crypto,
} = {}) => {
  const input = buildMlsKeyPackageRefInput(keyPackageBytes);
  if (!input || typeof cryptoRef?.subtle?.digest !== 'function') return null;

  const digest = await cryptoRef.subtle.digest(digestNameForCiphersuite(ciphersuite), input);
  return bytesToHex(new Uint8Array(digest));
};
